import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnchor, faCalendarAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import CustomBoatLeadModal from '../../../core/components/HomePage/CustomBoatLeadModal';

const BlogBoatCTA = () => {
  const [showLeadModal, setShowLeadModal] = useState(false);

  return (
    <div className="blog-boat-cta">
      <div className="blog-boat-cta__content">
        <h3>Ready for Your Sea Adventure?</h3>
        <p>Discover our premium fleet of yachts and luxury vessels. Book now and get exclusive discounts for your next aquatic getaway.</p>
        <div className="blog-boat-cta__actions">
          <button 
            className="blog-boat-cta__button blog-boat-cta__button--primary"
            onClick={() => setShowLeadModal(true)}
          >
            <FontAwesomeIcon icon={faAnchor} />
            Book Now
          </button>
          <Link to="/" className="blog-boat-cta__button blog-boat-cta__button--secondary">
            <FontAwesomeIcon icon={faCalendarAlt} />
            View Boats
          </Link>
        </div>
        <div className="blog-boat-cta__benefits">
          <div className="blog-boat-cta__benefit">
            <FontAwesomeIcon icon={faStar} />
            <span>24/7 Bookings</span>
          </div>
          <div className="blog-boat-cta__benefit">
            <FontAwesomeIcon icon={faStar} />
            <span>Guaranteed Prices</span>
          </div>
          <div className="blog-boat-cta__benefit">
            <FontAwesomeIcon icon={faStar} />
            <span>Premium Experience</span>
          </div>
        </div>
      </div>
      
      {showLeadModal && <CustomBoatLeadModal onClose={() => setShowLeadModal(false)} />}
    </div>
  );
};

export default BlogBoatCTA;
